// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S37x","right":"styles_right__91Ljz"};